import { useCallback, useRef } from "react";
import FlexRowDiv from "src/components/shared/elements/FlexRowDiv";
import LobbieCheckbox from "src/components/shared/forms/LobbieCheckbox";
import { LOBBIE_COLORS } from "src/utils/colors";
import { boldTextCSS, regularTextCSS } from "src/utils/klasses";

interface IProps {
    setIsNotifyEarlierAppointment: (notify: boolean) => void;
    appointmentLowerString?: string;
}

const PatientSchedulingEarlierAppoinmentNotify: React.FC<IProps> = ({
    setIsNotifyEarlierAppointment,
    appointmentLowerString,
}) => {
    const ref = useRef();

    const onClick = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setIsNotifyEarlierAppointment(e.target.checked);
        },
        [setIsNotifyEarlierAppointment],
    );

    const _appointmentLowerString = appointmentLowerString || "appointment";

    return (
        <FlexRowDiv
            style={{
                margin: "0 auto",
                backgroundColor: LOBBIE_COLORS.secondaryLighter,
                borderRadius: 4,
                paddingTop: 10,
                paddingBottom: 0,
                marginBottom: 5,
                paddingLeft: 10,
            }}
        >
            <LobbieCheckbox
                ref={ref}
                onClick={onClick}
                id="notifyOnEarlierAvailable"
                name="notifyOnEarlierAvailable"
                label={
                    <>
                        <span role="button" className={boldTextCSS}>
                            Notify me about earlier {_appointmentLowerString}s
                        </span>
                        <p className={`mt-1 ${regularTextCSS}`}>
                            Get an email notification when an earlier time slot becomes available.
                        </p>
                    </>
                }
                style={{ borderColor: LOBBIE_COLORS.primary }}
            />
        </FlexRowDiv>
    );
};

export default PatientSchedulingEarlierAppoinmentNotify;
